import {
  formatMoney,
  getRetailerFromId,
  hexadecimal,
  TABLET_SCREEN_SIZE,
} from "@brandclub/common-ui";

import { Box, styled, useTheme } from "@mui/material";

export const RewardExpandContainer = styled(Box)(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: "1fr 1fr",
  width: "100%",
  gap: 16,
  marginTop: 31,
  [theme.breakpoints.down("md")]: {
    marginTop: 20,
    gap: 8,
    gridTemplateColumns: "1fr",
  },
}));

const IconContainer = styled(Box)(({ theme }) => ({
  width: 36,
  height: 36,
  backgroundColor: hexadecimal(theme.palette.secondary.main)(50),
  borderRadius: 999,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

const RewardIcon = () => {
  const theme = useTheme();
  return (
    <IconContainer>
      <svg
        data-name="coins (1)"
        xmlns="http://www.w3.org/2000/svg"
        width="21.879"
        height="22.205"
        viewBox="0 0 21.879 22.205"
        style={{ fill: theme.palette.primary.main }}
      >
        <path
          data-name="Path 26001"
          d="M14.893 22.205c-3.386 0-6.986-1.05-6.986-2.993a.5.5 0 1 1 1 0c0 .833 2.277 2 5.988 2s5.988-1.163 5.988-2a.5.5 0 1 1 1 0c-.004 1.943-3.603 2.993-6.99 2.993z"
        />
        <path
          data-name="Path 26002"
          d="M14.893 19.16c-3.386 0-6.986-1.05-6.986-2.993a.5.5 0 1 1 1 0c0 .833 2.277 2 5.988 2s5.988-1.163 5.988-2a.5.5 0 1 1 1 0c-.004 1.943-3.603 2.993-6.99 2.993z"
        />
        <path
          data-name="Path 26003"
          d="M14.893 16.072c-3.386 0-6.986-1.05-6.986-2.994s3.6-2.994 6.986-2.994 6.986 1.05 6.986 2.994-3.599 2.994-6.986 2.994zm0-4.99c-3.71 0-5.988 1.163-5.988 2s2.277 2 5.988 2 5.988-1.163 5.988-2-2.274-1.998-5.988-1.998z"
        />
        <path
          data-name="Path 26004"
          d="M21.38 19.711a.5.5 0 0 1-.5-.509v-6.114a.5.5 0 1 1 1 0v6.113a.5.5 0 0 1-.5.51z"
        />
        <path
          data-name="Path 26005"
          d="M8.407 19.711a.5.5 0 0 1-.5-.509v-6.114a.5.5 0 1 1 1 0v6.113a.5.5 0 0 1-.5.51z"
        />
        <path
          data-name="Path 26006"
          d="M6.986 11.976C3.6 11.976 0 10.926 0 8.983a.5.5 0 1 1 1 0c0 .833 2.277 2 5.988 2s5.988-1.163 5.988-2a.5.5 0 1 1 1 0c-.004 1.943-3.603 2.993-6.99 2.993z"
        />
        <path
          data-name="Path 26007"
          d="M6.986 8.982C3.6 8.982 0 7.932 0 5.989a.5.5 0 1 1 1 0c0 .833 2.277 2 5.988 2s5.988-1.163 5.988-2a.5.5 0 1 1 1 0c-.004 1.943-3.603 2.993-6.99 2.993z"
        />
        <path
          data-name="Path 26008"
          d="M6.986 17.964C3.6 17.964 0 16.914 0 14.971a.5.5 0 1 1 1 0c0 .833 2.277 2 5.988 2a13.848 13.848 0 0 0 1.444-.067.5.5 0 1 1 .106.992 14.523 14.523 0 0 1-1.55.073z"
        />
        <path
          data-name="Path 26009"
          d="M6.986 20.958C3.6 20.958 0 19.908 0 17.965a.5.5 0 1 1 1 0c0 .833 2.277 2 5.988 2a13.847 13.847 0 0 0 1.444-.067.5.5 0 0 1 .106.992 14.524 14.524 0 0 1-1.55.073z"
        />
        <path
          data-name="Path 26010"
          d="M6.986 14.97C3.6 14.97 0 13.92 0 11.977a.5.5 0 1 1 1 0c0 .833 2.277 2 5.988 2a13.848 13.848 0 0 0 1.444-.067.5.5 0 0 1 .106.992 14.523 14.523 0 0 1-1.55.073z"
        />
        <path
          data-name="Path 26011"
          d="M6.986 5.988C3.6 5.988 0 4.938 0 2.994S3.6 0 6.986 0s6.986 1.05 6.986 2.994-3.599 2.994-6.986 2.994zm0-4.99C3.275 1 1 2.161 1 2.994s2.277 2 5.988 2 5.988-1.163 5.988-2S10.7 1 6.986 1z"
        />
        <path
          data-name="Path 26012"
          d="M.5 18.463a.5.5 0 0 1-.5-.5V2.995a.5.5 0 1 1 1 0v14.97a.5.5 0 0 1-.5.498z"
        />
        <path
          data-name="Path 26013"
          d="M13.474 10.518a.5.5 0 0 1-.5-.5V2.995a.5.5 0 1 1 1 0v7.025a.5.5 0 0 1-.5.498z"
        />
      </svg>
    </IconContainer>
  );
};

const CustomerSupportIcon = () => {
  const theme = useTheme();
  return (
    <IconContainer>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24.255"
        height="22.751"
        viewBox="0 0 23.255 22.751"
        style={{
          fill: theme.palette.primary.main,
          stroke: theme.palette.primary.main,
        }}
      >
        <path
          data-name="Path 25954"
          d="M87.6 423.387h-1.468a2.133 2.133 0 0 1-2.132-2.13v-3.777a2.133 2.133 0 0 1 2.13-2.13h1.47a.443.443 0 0 1 .443.443v7.151a.443.443 0 0 1-.443.443zm-1.468-7.151a1.246 1.246 0 0 0-1.246 1.244v3.776a1.246 1.246 0 0 0 1.244 1.244h1.025v-6.265z"
          transform="translate(-83.9 -406.318)"
          style={{ strokeWidth: ".2px" }}
        />
        <path
          data-name="Path 25955"
          d="M200.334 423.387h-1.891a.443.443 0 0 1-.443-.443v-7.151a.443.443 0 0 1 .443-.443h1.893a.443.443 0 0 1 .443.443v7.151a.443.443 0 0 1-.445.443zm-1.45-.886h1.006v-6.265h-1.005z"
          transform="translate(-194.743 -406.318)"
          style={{ strokeWidth: ".2px" }}
        />
        <path
          data-name="Path 25956"
          d="M771.991 423.387h-1.468a.443.443 0 0 1-.443-.443v-7.151a.443.443 0 0 1 .443-.443h1.468a2.133 2.133 0 0 1 2.13 2.13v3.776a2.133 2.133 0 0 1-2.13 2.131zm-1.025-.886h1.025a1.246 1.246 0 0 0 1.244-1.244v-3.777a1.246 1.246 0 0 0-1.244-1.244h-1.025z"
          transform="translate(-750.967 -406.318)"
          style={{ strokeWidth: ".2px" }}
        />
        <path
          data-name="Path 25957"
          d="M704.046 423.387h-1.893a.443.443 0 0 1-.443-.443v-7.151a.443.443 0 0 1 .443-.443h1.893a.443.443 0 0 1 .443.443v7.151a.443.443 0 0 1-.443.443zm-1.45-.886h1.004v-6.265h-1z"
          transform="translate(-684.49 -406.318)"
          style={{ strokeWidth: ".2px" }}
        />
        <path
          data-name="Path 25958"
          d="M185.515 102.911h-2.137a.443.443 0 0 1-.443-.443 6.35 6.35 0 0 0-12.7 0 .443.443 0 0 1-.443.443h-2.137a.443.443 0 0 1-.443-.443 9.374 9.374 0 0 1 18.748 0 .443.443 0 0 1-.445.443zm-1.707-.886h1.252a8.488 8.488 0 0 0-16.952 0h1.252a7.238 7.238 0 0 1 14.448 0z"
          transform="translate(-164.806 -93)"
          style={{ strokeWidth: ".2px" }}
        />
        <path
          data-name="Path 25959"
          d="M546.477 679.285a.443.443 0 0 1-.048-.884c5.031-.559 5.814-3.877 5.821-3.911a.443.443 0 0 1 .865.19 5.154 5.154 0 0 1-1.177 2.1 6.8 6.8 0 0 1-2.01 1.536 9.85 9.85 0 0 1-3.4.964z"
          transform="translate(-533.127 -657.954)"
          style={{ strokeWidth: ".2px" }}
        />
        <path
          data-name="Path 25960"
          d="M435.154 788.989h-.665a1.679 1.679 0 0 1 0-3.359h.665a1.679 1.679 0 1 1 0 3.359zm-.665-2.473a.793.793 0 1 0 0 1.586h.665a.793.793 0 1 0 0-1.586z"
          transform="translate(-423.043 -766.338)"
          style={{ strokeWidth: ".2px" }}
        />
      </svg>
    </IconContainer>
  );
};

const SecurityIcon = () => {
  const theme = useTheme();
  return (
    <IconContainer>
      <svg
        stroke={theme.palette.primary.main}
        xmlns="http://www.w3.org/2000/svg"
        width="22.001"
        height="22.001"
        viewBox="0 0 22.001 22.001"
      >
        <defs>
          <clipPath id="y4qslnvbva">
            <path d="M0-682.665h22v22H0z" transform="translate(0 682.665)" />
          </clipPath>
        </defs>
        <g style={{ clipPath: "url(#y4qslnvbva)" }}>
          <path
            d="M-426.739-388.721h-12.888a1.323 1.323 0 0 1-1.323-1.323v-10.3a1.323 1.323 0 0 1 1.323-1.323h12.888a1.323 1.323 0 0 1 1.323 1.323v10.3a1.323 1.323 0 0 1-1.323 1.323z"
            transform="translate(444.184 410.077)"
            style={{
              fill: "none",

              strokeLinecap: "round",
              strokeLinejoin: "round",
              strokeMiterlimit: "10",
              strokeWidth: "1.25px",
            }}
          />
          <path
            d="M-77.744-38.872a1.294 1.294 0 0 1-1.294 1.294 1.294 1.294 0 0 1-1.294-1.294 1.294 1.294 0 0 1 1.294-1.294 1.294 1.294 0 0 1 1.294 1.294z"
            transform="translate(90.039 52.574)"
            style={{
              fill: "none",

              strokeLinecap: "round",
              strokeLinejoin: "round",
              strokeMiterlimit: "10",
              strokeWidth: "1.25px",
            }}
          />
          <path
            d="M0 0v2.589"
            style={{
              fill: "none",

              strokeLinecap: "round",
              strokeLinejoin: "round",
              strokeMiterlimit: "10",
              strokeWidth: "1.25px",
            }}
            transform="translate(11 14.996)"
          />
          <path
            d="M-310.654-233.232h-2.578v-2.9a2.292 2.292 0 0 0-2.292-2.292h-.605a2.292 2.292 0 0 0-2.292 2.292v2.9H-321v-2.594a5.173 5.173 0 0 1 5.173-5.174h0a5.173 5.173 0 0 1 5.173 5.173z"
            transform="translate(326.827 241.644)"
            style={{
              fill: "none",

              strokeLinecap: "round",
              strokeLinejoin: "round",
              strokeMiterlimit: "10",
              strokeWidth: "1.25px",
            }}
          />
        </g>
      </svg>
    </IconContainer>
  );
};

const ShippingIcon = () => {
  const theme = useTheme();
  return (
    <IconContainer>
      <svg
        stroke={theme.palette.primary.main}
        xmlns="http://www.w3.org/2000/svg"
        width="20.069"
        height="20.069"
        viewBox="0 0 20.069 20.069"
      >
        <defs>
          <clipPath id="zu67o0bd1a">
            <path
              d="M0-682.665h20.07v20.07H0z"
              transform="translate(0 682.665)"
            />
          </clipPath>
        </defs>
        <g style={{ clipPath: "url(#zu67o0bd1a)" }}>
          <path
            d="M-582.182 0a3.041 3.041 0 0 0-2.15.891L-596.037 12.6h-2.52a1.259 1.259 0 0 0-1.259 1.259h0l3.149 1.889 1.889 3.149a1.259 1.259 0 0 0 .891-.369 1.259 1.259 0 0 0 .369-.891v-2.522l11.705-11.705a3.041 3.041 0 0 0 .891-2.15h0A1.259 1.259 0 0 0-582.181 0h0z"
            transform="translate(600.404 .588)"
            style={{
              fill: "none",

              strokeLinecap: "round",
              strokeLinejoin: "round",
              strokeMiterlimit: "10",
              strokeWidth: "1.25px",
            }}
          />
          <path
            d="m-395.056-68.881-8.5-2a3.27 3.27 0 0 0-3.47 1.369h0l8.187 4.409"
            transform="translate(407.61 73.877)"
            style={{
              fill: "none",

              strokeLinecap: "round",
              strokeLinejoin: "round",
              strokeMiterlimit: "10",
              strokeWidth: "1.25px",
            }}
          />
          <path
            d="m-124.754 0 2 8.5a3.27 3.27 0 0 1-1.369 3.47h0l-4.409-8.187"
            transform="translate(139.827 7.516)"
            style={{
              fill: "none",

              strokeLinecap: "round",
              strokeLinejoin: "round",
              strokeMiterlimit: "10",
              strokeWidth: "1.25px",
            }}
          />
        </g>
      </svg>
    </IconContainer>
  );
};

const ReturnIcon = () => {
  const theme = useTheme();
  return (
    <IconContainer>
      <svg
        fill={theme.palette.primary.main}
        stroke={theme.palette.primary.main}
        xmlns="http://www.w3.org/2000/svg"
        width="22.95"
        height="23.261"
        viewBox="0 0 23.45 23.261"
      >
        <path
          data-name="Path 25927"
          d="M4.555 19.319a10.587 10.587 0 0 1-1.738-6.861 11.181 11.181 0 0 1 .275-1.658 10.22 10.22 0 0 1 .468-1.408 10.739 10.739 0 0 1 5.316-5.613 10.622 10.622 0 0 1 1.567-.592 9.888 9.888 0 0 1 1.452-.312.319.319 0 0 0 .05-.011 10.58 10.58 0 0 1 7.738 1.922q.328.238.637.5l-.8.043a.381.381 0 0 0 .02.761h.021L21.258 6a.364.364 0 0 0 .105-.028c.009 0 .019 0 .028-.007a.379.379 0 0 0 .069-.047.389.389 0 0 0 .054-.041l.008-.006a.323.323 0 0 0 .026-.045.374.374 0 0 0 .045-.077.393.393 0 0 0 .011-.056.363.363 0 0 0 .016-.078v-.023l-.1-1.7a.384.384 0 0 0-.4-.358.38.38 0 0 0-.358.4l.038.766a11.119 11.119 0 0 0-.674-.529 11.341 11.341 0 0 0-8.337-2.053.363.363 0 0 0-.045.01 10.636 10.636 0 0 0-1.518.329 11.416 11.416 0 0 0-1.678.634A11.495 11.495 0 0 0 2.857 9.1a10.975 10.975 0 0 0-.5 1.519 11.87 11.87 0 0 0-.295 1.768 11.348 11.348 0 0 0 1.864 7.353.381.381 0 1 0 .632-.424z"
          transform="translate(-1.807 -1.787)"
          style={{ strokeWidth: ".4px" }}
        />
        <path
          data-name="Path 25928"
          d="M27.672 15.025a.381.381 0 0 0-.1.529 10.587 10.587 0 0 1 1.738 6.861 11.181 11.181 0 0 1-.275 1.653 10.22 10.22 0 0 1-.468 1.413 10.739 10.739 0 0 1-5.316 5.613 10.622 10.622 0 0 1-1.567.592 9.887 9.887 0 0 1-1.456.314.319.319 0 0 0-.05.011 10.584 10.584 0 0 1-7.738-1.922 10.639 10.639 0 0 1-.637-.5l.8-.045a.381.381 0 0 0-.042-.76l-1.7.094a.38.38 0 0 0-.359.4l.094 1.7a.38.38 0 0 0 .38.36H11a.38.38 0 0 0 .359-.4l-.042-.76c.216.182.439.359.674.529a11.3 11.3 0 0 0 6.676 2.172 11.692 11.692 0 0 0 1.66-.119.363.363 0 0 0 .045-.01 10.636 10.636 0 0 0 1.518-.329 11.416 11.416 0 0 0 1.678-.634 11.495 11.495 0 0 0 5.7-6.013 10.975 10.975 0 0 0 .5-1.519 11.87 11.87 0 0 0 .295-1.768A11.348 11.348 0 0 0 28.2 15.13a.38.38 0 0 0-.528-.1z"
          transform="translate(-7.067 -9.814)"
          style={{ strokeWidth: ".4px" }}
        />
        <path
          data-name="Path 25929"
          d="M28.16 17.158a.278.278 0 0 0-.023-.114.114.114 0 0 0-.015-.038.342.342 0 0 0-.065-.1.053.053 0 0 0-.015-.011.249.249 0 0 0-.069-.057l-5.727-3.3a.378.378 0 0 0-.381 0L16.1 16.865a.381.381 0 0 0-.19.327v6.466c0 .015.008.03.008.046a.305.305 0 0 0 .019.08.183.183 0 0 0 .03.061.218.218 0 0 0 .042.061.329.329 0 0 0 .053.05c.015.011.023.027.038.034l5.727 3.305c.008.008.019.008.027.015l.03.011a.4.4 0 0 0 .133.027.415.415 0 0 0 .133-.027l.027-.011.03-.011 5.765-3.332c.015-.008.023-.023.038-.034a.307.307 0 0 0 .053-.046.4.4 0 0 0 .046-.065.3.3 0 0 0 .027-.061.305.305 0 0 0 .019-.08c0-.015.008-.027.008-.046v-6.477zm-6.1-2.852 4.966 2.864-1.9 1.1-4.966-2.87zm-.419 12-4.966-2.867v-5.584l4.966 2.864zm.377-6.249-4.962-2.867 2.344-1.35 4.964 2.86zm5.382 3.361-5 2.89v-5.59l2.346-1.356V20.4a.381.381 0 0 0 .762 0v-1.475l1.9-1.1z"
          transform="translate(-10.413 -8.9)"
          style={{ strokeWidth: ".4px" }}
        />
      </svg>
    </IconContainer>
  );
};

const benefitList = [
  {
    icon: <SecurityIcon />,
    title: "Best in class security practices",
  },
  {
    icon: <ShippingIcon />,
    title: "Get fast, free shipping",
  },
  {
    icon: <ReturnIcon />,
    title: "Easy returns and refunds",
  },
];

const BenefitsContent = styled("div")(({ theme }) => ({
  overflowY: "auto",
  flex: 1,
  paddingBottom: 8,
  paddingTop: 8,
  display: "flex",
  flexDirection: "column",
  gap: "12px",
  maxWidth: 380,
  width: "100%",

  [`@media screen and (max-width: ${TABLET_SCREEN_SIZE}px)`]: {
    gap: "5px",
  },
  "&::-webkit-scrollbar": {
    width: 4,
  },
  "&::-webkit-scrollbar-track": {
    background: "transparent",
  },
  "&::-webkit-scrollbar-thumb": {
    background: hexadecimal(theme.palette.primary.main)(20),
    borderRadius: 2,
  },
}));

const BenefitCardRow = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: 16,
  padding: "6px 16px",
  [`@media screen and (max-width: ${TABLET_SCREEN_SIZE}px)`]: {
    gap: 10,
  },
}));

const BenefitCardText = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  color: theme.palette.primary.main,
}));

const BenefitCardTitle = styled("div")(({ theme }) => ({
  fontWeight: 600,
  fontSize: 16,
  color: theme.palette.primary.main,
  marginBottom: 2,
  [`@media screen and (max-width: ${TABLET_SCREEN_SIZE}px)`]: {
    fontSize: 14,
  },
}));

export const RetailerConnectBenefits = ({
  rewardAmount,
  retailerId,
}: {
  rewardAmount?: number;
  retailerId?: number;
}) => {
  const retailerName = retailerId ? getRetailerFromId(retailerId) : "retailer";
  return (
    <BenefitsContent>
      {rewardAmount && rewardAmount > 0 ? (
        <BenefitCardRow>
          <RewardIcon />
          <BenefitCardText>
            <BenefitCardTitle>
              Earn {formatMoney(rewardAmount)} by connecting {retailerName}
            </BenefitCardTitle>
          </BenefitCardText>
        </BenefitCardRow>
      ) : null}
      <BenefitCardRow>
        <CustomerSupportIcon />
        <BenefitCardText>
          <BenefitCardTitle>
            Use {retailerName}’s customer service
          </BenefitCardTitle>
        </BenefitCardText>
      </BenefitCardRow>
      {benefitList.map((benefit) => (
        <BenefitCardRow key={benefit.title}>
          {benefit.icon}
          <BenefitCardText>
            <BenefitCardTitle>{benefit.title}</BenefitCardTitle>
          </BenefitCardText>
        </BenefitCardRow>
      ))}
    </BenefitsContent>
  );
};
